/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TravelineVatDto
 */
export interface TravelineVatDto {
    /**
     * Is VAT payable<br />
     * If false - VAT is not payable, so Included and Percent are not specified
     * @type {boolean}
     * @memberof TravelineVatDto
     */
    applicable: boolean;
    /**
     * Is VAT included in TotalPrice
     * @type {boolean}
     * @memberof TravelineVatDto
     */
    included?: boolean | null;
    /**
     * Percentage
     * @type {number}
     * @memberof TravelineVatDto
     */
    percent?: number | null;
}

/**
 * Check if a given object implements the TravelineVatDto interface.
 */
export function instanceOfTravelineVatDto(value: object): value is TravelineVatDto {
    if (!('applicable' in value) || value['applicable'] === undefined) return false;
    return true;
}

export function TravelineVatDtoFromJSON(json: any): TravelineVatDto {
    return TravelineVatDtoFromJSONTyped(json, false);
}

export function TravelineVatDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineVatDto {
    if (json == null) {
        return json;
    }
    return {
        
        'applicable': json['applicable'],
        'included': json['included'] == null ? undefined : json['included'],
        'percent': json['percent'] == null ? undefined : json['percent'],
    };
}

  export function TravelineVatDtoToJSON(json: any): TravelineVatDto {
      return TravelineVatDtoToJSONTyped(json, false);
  }

  export function TravelineVatDtoToJSONTyped(value?: TravelineVatDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicable': value['applicable'],
        'included': value['included'],
        'percent': value['percent'],
    };
}

